<template>
  <div class="share">
    <div class="topbg">
      <div class="logo"><img src="../assets/img/logo.png" alt="" /></div>
      <div class="title subtitle">定位有术</div>
      <div class="subtitle">实时定位查询，守护亲友安全</div>
    </div>
    <div class="content-wapper">
      <div class="content">
        <div class="user-wapper">
          <img
            :src="photoUrl"
            alt=""
          />
          <span>{{phoneNum}}</span>
        </div>
        <div class="subtitle">您的好友邀请您共享实时位置</div>
        <div class="ipt"><input v-model="tel" placeholder="请输入手机号" type="text" /></div>
        <div class="desc">输入手机号码方便亲友找到您哦</div>
      </div>
      <div class="btn" @click="upLoad">立即下载</div>
    </div>
    <div class="mask-loading" v-if="showMask" @click="showMask = false">
      <div id="">
        <img class="mask-arrow" src="../assets/img/weixinh5_arrow.png" />
      </div>
      <img class="mask-text" src="../assets/img/weixinh5_main.png" />
    </div>
  </div>
</template>

<script>
import { isWeChatDevTools } from "../utils/env";
export default {
  data() {
    return {
      showMask: false,
      tel :"",
      token: this.$route.query.token || "",
      photoUrl : this.$route.query.photoUrl ? window.atob(this.$route.query.photoUrl) : "",
      phoneNum : this.$route.query.phoneNum || ""
    };
  },
  created() {
    if (!isWeChatDevTools) this.getAppApkVersion();
  },
  methods: {
    async getAppApkVersion() {
      let res = await this.$api.getAppApkVersion();
      let data = res.data;
      window.apkUrl = data;
    },
    async upLoad() {
      if (isWeChatDevTools) return (this.showMask = true);
      if(this.tel == ""){
        return window.location.href = window.apkUrl.image_url;
      }
      
      if (
        !/^1\d{10}$/.test(this.tel)
      ) {
        return this.$toast("手机号码填写错误，请重新填写");
      }
      try {
        
        let res = await this.$api.setProcess({
          phone: this.tel,
          isLogin : true,
          token : this.token
        });
      } catch (error) {
        
      }
      return window.location.href = window.apkUrl.image_url;
    },
  },
};
</script>

<style lang="less">
body {
  background: #f4f6f8;
}
.share {
  .topbg {
    height: 43vh;
    background: url("../assets/img/sharebg.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .logo {
      img {
        width: 22.222vw;
      }
    }
    .title {
      margin: 1.691vw 0;
    }
    .subtitle {
      font-size: 3.865vw;
      color: #fff;
      opacity: 0.9;
    }
  }
  .content-wapper {
    text-align: center;
    margin-top: -8vh;
  }
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    display: inline-block;
    width: 91.063vw;
    height: 58.454vw;
    background: #fff;
    border-radius: 5.556vw;
    .ipt {
      display: inline-block;
      margin: 6.763vw 0 4.348vw 0;
      height: 10.628vw;
      width: 65.459vw;
      background: #f4f6f8;
      border-radius: 6.763vw;
      overflow: hidden;
      input {
        outline: none;
        height: 100%;
        width: 100%;
        color: #a6b2bf;
        font-size: 3.865vw;
        background: #f4f6f8;
        padding-left: 6.28vw;
      }
    }
    .user-wapper {
      margin-top: 6.763vw;
      margin-bottom: 4.348vw;
      img {
        width: 9.903vw;
        margin-right: 4.348vw;
        border-radius: 50%;
        vertical-align: middle;
      }
      span {
        color: #191e34;
        font-size: 4.348vw;
      }
    }
    .desc {
      font-size: 2.899vw;
      color: #a6b2bf;
    }
    .subtitle {
      font-size: 4.348vw;
      color: #1a213c;
    }
  }
  .btn {
    margin-top: 6.763vw;
    background: #34dda5;
    font-size: 4.348vw;
    text-align: center;
    color: #fff;
    border-radius: 7.488vw;
    width: 61.111vw;
    height: 12.319vw;
    line-height: 12.319vw;
    display: inline-block;
  }
  .mask-loading {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    text-align: center;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 99999;
  }
  .mask-loading > div {
    text-align: right;
  }
  .mask-loading .mask-arrow {
    padding-top: 20px;
    width: 18%;
    margin-right: 5%;
  }
  .mask-loading .mask-text {
    width: 80%;
    margin-top: -7px;
  }
}
</style>